import React, { useEffect, useState } from "react"
// import ProjectData from "../../../services/DatabaseService/ProjectData";
import ProjectData from "../../../services/DatabaseService/ProjectData"

export default function AllProject() {
    const [ projectList, setProjectList] = useState([]);
    const [loading,setLoading] = useState(true);
    
    useEffect(() => {
        console.log("API Triggered")
        const fetchData = async() => {
            try{
            const result = await ProjectData.getProject();
            setProjectList(result)
            }catch(error){
                console.log("Error fetching data",error);
            }finally{
                setLoading(false);
            }
        };
        fetchData();
    },[])
    console.log(projectList)
    return(
        <div>
              {projectList.map((project) => (
                <div key={project.id}>{project.name}</div>
            ))}
        </div>
    )
}